import { ShopSymbol } from "../constants";
import { FareWarningLevel, MaybeHasFee, } from "./interfaces";
var penalty = {
    penalty: {
        message: "View on spirit.com",
        MaybeHasFee: MaybeHasFee.NO_FEE,
    },
    fareWarningLevel: {
        link: "https://customersupport.spirit.com/hc/en-us/articles/202097076-How-can-I-change-or-cancel-my-reservation-",
        FareWarningLevel: FareWarningLevel.NORMAL,
    },
    symbol: ShopSymbol.UNKNOWN,
};
export var slicedRestriction = {
    penaltiesInfo: {
        changePenalty: penalty,
        cancelPenalty: penalty,
    },
    canFilter: true,
    restrictionsWithInfo: [
        {
            title: "Hopper Customer Support",
            body: "Guaranteed assistance with your trip",
            restrictionWarningLevel: {
                RestrictionWarningLevel: "Normal",
            },
            symbol: "Included",
        },
    ],
    brandType: "BasicEconomy",
    detailBaggageInfo: {
        title: "Checked Bags",
        body: "Check with airlines for detail",
        restrictionWarningLevel: {
            RestrictionWarningLevel: "Normal",
        },
        symbol: "Unknown",
    },
    fetchReq: "eyJ0cmlwSWQiOiJqa1pxTkttcldxMHZWOERKQjFyVDN3bGNGMjFRRWQiLCJmYXJlSWQiOiJmNjNjYzFmYi0zMGFkLTRkYmYtOTYxZC1mNmE2Y2E5ZTRmMTciLCJtYXJrZXRpbmdDYXJyaWVycyI6WyJOSyIsIkY5Il19",
    baggageInfo: {
        LocalizedBaggageInfo: "Unknown",
    },
};
export var fareRestrictions = {
    penaltiesInfo: {
        changePenalty: penalty,
        cancelPenalty: penalty,
    },
    canFilter: true,
    restrictionsWithInfo: [
        {
            title: "Hopper Customer Support",
            body: "Guaranteed assistance with your trip",
            restrictionWarningLevel: {
                RestrictionWarningLevel: "Normal",
            },
            symbol: "Included",
        },
    ],
    brandType: "BasicEconomy",
    detailBaggageInfo: {
        title: "Checked Bags",
        body: "Check with airlines for detail",
        restrictionWarningLevel: {
            RestrictionWarningLevel: "Normal",
        },
        symbol: "Unknown",
    },
    fetchReq: "eyJ0cmlwSWQiOiJqa1pxTkttcldxMHZWOERKQjFyVDN3bGNGMjFRRWQiLCJmYXJlSWQiOiJmNjNjYzFmYi0zMGFkLTRkYmYtOTYxZC1mNmE2Y2E5ZTRmMTciLCJtYXJrZXRpbmdDYXJyaWVycyI6WyJOSyIsIkY5Il19",
    baggageInfo: {
        LocalizedBaggageInfo: "Unknown",
    },
};
export var restrictions = [
    {
        name: "Seat Selection",
        description: "Available",
        symbol: ShopSymbol.INCLUDED,
    },
    {
        name: "Carry-on Bags",
        description: "Overhead bin access",
        symbol: ShopSymbol.INCLUDED,
    },
    {
        name: "Checked Bags",
        description: "Free\n2nd bag: $70",
        symbol: ShopSymbol.INCLUDED,
    },
    {
        name: "Cancellations",
        description: "$25",
        symbol: ShopSymbol.PURCHASABLE,
    },
    {
        name: "Changes",
        description: "$25",
        symbol: ShopSymbol.PURCHASABLE,
    },
];
//# sourceMappingURL=fixtures.js.map